"use client";

import { useTaskNotes } from "@/lib/hooks/api/tasks";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Contact_TasksDetail } from "@/lib/types/task-extensions";
import { TaskAISummary } from "../components/TaskAISummary";

export function TaskAISummaryTab({
  item,
  tab,
  onRefresh: _onRefresh,
  autoGenerate = false,
  showMetadata = true,
  showRefreshButton = true,
  showClearButton = false,
  compact = false,
  className,
}: TabContentProps<Contact_TasksDetail> & {
  autoGenerate?: boolean;
  showMetadata?: boolean;
  showRefreshButton?: boolean;
  showClearButton?: boolean;
  compact?: boolean;
  className?: string;
}) {
  const { data: liveTaskNotes } = useTaskNotes(item.id);

  return (
    <div className={className ?? "w-full"}>
      <TaskAISummary
        taskId={item.id}
        taskTitle={item.title ?? ""}
        taskDescription={item.description ?? undefined}
        taskNotes={(liveTaskNotes || []).map((note) => ({
          ...note,
          note_type: note.note_type ?? "general",
          is_internal: Boolean(note.is_internal),
        }))}
        autoGenerate={autoGenerate}
        showMetadata={showMetadata}
        showRefreshButton={showRefreshButton}
        showClearButton={showClearButton}
        compact={compact}
        className="w-full"
        onSummaryGenerated={(summary) => {
          console.log("Task AI Summary generated:", item.id);
        }}
        onError={(error) => {
          console.error("Task AI Summary error:", error);
        }}
      />
    </div>
  );
}
